module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_5.36e31794.jpg";